import genericWidget from '@components/mixins/genericWidget'
import ImageContentItem from '@components/Widgets/_contentItems/Image/Image.vue'

export default {
  name: 'ImageColumnWidget',
  components: {
    'image-content-item': ImageContentItem,
  },
  mixins: [genericWidget],
  data() {
    return {
      hoveredImageComponentId: '',
    }
  },
  methods: {
    imageHovered(componentId, mouseOver) {
      this.hoveredImageComponentId = mouseOver ? componentId : ''
    },
  },
}
